import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import { handleGetRequest } from '../../service/GetTemplate';
import { endPoints } from '../../Config';

import { useDispatch } from 'react-redux';

import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { handlePostRequest } from '../../service/PostTemplate';

const CaptureVoid = () => {
    const [allRoles, setAllRoles] = useState([]);
    const [viewable, setViewable] = useState(false);

    const [loadingBtn, setLoadingBtn] = useState(false);

    const dispatch = useDispatch();
    const formik = useFormik({
        // validationSchema: validationSchema,
        initialValues: {
            id: '',
            customerName: '',
            phoneNumber: '',
            consumerId: '',
            dateOfBirth: '',
            cnic: '',
            gender: '',
            emailAddress: '',
            address: '',
            profileImageBase64: '',
            profileImagePath: '',
            createdBy: ''
        },
        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('user') || '{}');

            setLoadingBtn(true);
            const addData = {
                roleName: data.roleName,
                createdBy: user?.user?.userId
            };

            const editData = {
                id: data.id,
                roleName: data.roleName,
                modifiedBy: user?.user?.userId
            };

            const response = await dispatch(handlePostRequest(addData, endPoints.addRole, true));
            if (response?.status === 200) {
                formik.resetForm();
                //   onHide();
            }
            setLoadingBtn(false);
        }
    });

    // const handleAdd = () => {
    //     setShowAddDialog(true);
    //     setEditable(false);
    //     setViewable(false);
    // };

    // const handleEdit = (rowData) => {
    //     setShowAddDialog(true);
    //     setEditable(true);
    //     setViewable(false);
    //     setRowRecord(rowData);
    // };

    // const handleView = (rowData) => {
    //     setShowAddDialog(true);
    //     setEditable(false);
    //     setViewable(true);
    //     setRowRecord(rowData);
    // };

    // const handleInputSwitch = async () => {
    //     setLoadingBtn(true);

    //     let data = {
    //         isActive: switchData?.isActive ? false : true
    //     };

    //     const response = await dispatch(handlePutRequest(data, endPoints?.updateRole, false, true));

    //     if (response?.status === 200) {
    //         getRoleList();
    //     }

    //     setLoadingBtn(false);
    //     handleSwitchModalClose();
    // };

    // const handleSwitchModalOpen = () => {
    //     setSwitchModal(true);
    // };

    // const handleSwitchModalClose = () => {
    //     setSwitchModal(false);
    // };

    // const actionBodyTemplate = (rowData) => {
    //     return (
    //         <>
    //             <div className="actions">
    //                 <InputSwitch
    //                     tooltip="Status"
    //                     tooltipOptions={{ position: 'top' }}
    //                     checked={rowData.isActive}
    //                     onChange={() => {
    //                         handleSwitchModalOpen();
    //                         setSwitchData(rowData);
    //                     }}
    //                 />

    //                 <Button
    //                     tooltip="Edit"
    //                     icon="pi pi-pencil"
    //                     tooltipOptions={{ position: 'top' }}
    //                     disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.isActive === 'N') ? true : false}
    //                     onClick={() => {
    //                         handleEdit(rowData);
    //                     }}
    //                     className="p-button-rounded p-button-primary mr-2 ml-2"
    //                 />
    //                 <Button
    //                     tooltip="View"
    //                     tooltipOptions={{ position: 'top' }}
    //                     icon="pi pi-eye"
    //                     onClick={() => {
    //                         handleView(rowData);
    //                     }}
    //                     className="p-button-rounded"
    //                     style={{ backgroundColor: '#F2AC57', border: 'none' }}
    //                 />
    //             </div>
    //         </>
    //     );
    // };

    const getRoleList = async () => {
        const response = await handleGetRequest(endPoints.getallRoles, true, false, dispatch);
        if (response) {
            setAllRoles(response);
        }
    };

    useEffect(() => {
        getRoleList();
    }, []);

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const previousDate = currentDate.toISOString().split('T')[0];
    return (
        <div className="p-4">
            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid grid mb-5">
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="roleName">Start Date</label>
                                <InputText id="dateTo" type="date" name="dateTo" max={previousDate} value={formik?.values?.dateTo || ''} onChange={formik.handleChange} />

                                {formik.touched.roleName && formik.errors.roleName && <small className="p-error">{formik.errors.roleName}</small>}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="roleName">End Date</label>
                                <InputText id="dateTo" type="date" name="dateTo" max={previousDate} value={formik?.values?.dateTo || ''} onChange={formik.handleChange} />

                                {formik.touched.roleName && formik.errors.roleName && <small className="p-error">{formik.errors.roleName}</small>}
                            </div>
                        </div>
                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="gender">Stores/Outlets</label>
                                <Dropdown id="gender" name="gender" value={formik?.values?.gender} options={[]} optionLabel="name" optionValue="id" onChange={formik.handleChange} placeholder="Select Gender" className="w-full" />
                                {formik.touched.gender && formik.errors.gender && <small className="p-error">{formik.errors.gender}</small>}
                            </div>
                        </div>{' '}
                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="gender">Card Scheme</label>
                                <Dropdown id="gender" name="gender" value={formik?.values?.gender} options={[]} optionLabel="name" optionValue="id" onChange={formik.handleChange} placeholder="Select Gender" className="w-full" />
                                {formik.touched.gender && formik.errors.gender && <small className="p-error">{formik.errors.gender}</small>}
                            </div>
                        </div>{' '}
                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="gender">3DS Card</label>
                                <Dropdown id="gender" name="gender" value={formik?.values?.gender} options={[]} optionLabel="name" optionValue="id" onChange={formik.handleChange} placeholder="Select Gender" className="w-full" disabled={viewable} />
                                {formik.touched.gender && formik.errors.gender && <small className="p-error">{formik.errors.gender}</small>}
                            </div>
                        </div>{' '}
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="roleName">Transaction ID</label>
                                <InputText id="roleName" name="roleName" placeholder="Enter Role Name" value={formik?.values?.roleName} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                                {formik.touched.roleName && formik.errors.roleName && <small className="p-error">{formik.errors.roleName}</small>}
                            </div>
                        </div>
                        <div className="live__SearchBtn p-field col-12 md:col-12">
                            {/* <Button disabled={loading} loadingIcon={loadingIcon} icon={loadingIcon} iconPos="left" label="Search" className="Btn__Dark__Search" /> */}
                            <Button label="Search" icon="pi pi-search" className="Btn__Dark__Search" />

                            <Button
                                label="Reset"
                                // onClick={(e) => resetHandle(e)}
                                className="Btn__Transparent__Reset"
                            />
                        </div>
                    </div>
                </form>
            </div>
            <div className="Form__Header mt-5">
                <p className="text-2xl font-medium">Capture/Void</p>
            </div>
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <DataTable
                            paginator
                            rows={15}
                            rowsPerPageOptions={[5, 10, 20]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                            emptyMessage="No List found."
                            responsiveLayout="scroll"
                            value={[]}
                            className="p-datatable-sm datatable-responsive"
                        >
                            <Column field="lkpPartner.partnerName" header="Date " />
                            <Column field="" header="Order ID" />
                            <Column field="roleCode" header="Transaction ID" />
                            <Column field="email" header="PAN" />
                            <Column field="email" header="STAN" />
                            <Column field="email" header="Amount" />
                            <Column field="email" header="Issuer" />

                            <Column field="createdBy" header="Created By" />
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CaptureVoid;
